export const AccountTypes = {
  VET: { name: "Veterinario", apiPrefix: "/vets" },
  PRO: { name: "Professionista", apiPrefix: "/profs" },
};

export type AccountType = (typeof AccountTypes)[keyof typeof AccountTypes];
